import { render, staticRenderFns } from "./InstructorClass.vue?vue&type=template&id=5df21241&scoped=true&"
import script from "./InstructorClass.js?vue&type=script&lang=js&"
export * from "./InstructorClass.js?vue&type=script&lang=js&"
import style0 from "./InstructorClass.vue?vue&type=style&index=0&id=5df21241&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df21241",
  null
  
)

export default component.exports